(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('greeting', {
                parent: 'entity',
                url: '/greeting',
                data: {
                    authorities: [],
                    pageTitle: 'Greetings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/greeting/list/greeting.html',
                        controller: 'GreetingController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
